/**
 * Spanish (Spain/LATAM) Pokémon names — official localized names.
 */
const es: Record<string, string> = {
  venusaur: "Venusaur",
  charizard: "Charizard",
  "mega-charizard-x": "Mega-Charizard X",
  "mega-charizard-y": "Mega-Charizard Y",
  blastoise: "Blastoise",
  pikachu: "Pikachu",
  "alolan-raichu": "Raichu de Alola",
  clefable: "Clefable",
  "alolan-ninetales": "Ninetales de Alola",
  wigglytuff: "Wigglytuff",
  meowth: "Meowth",
  psyduck: "Psyduck",
  machamp: "Machamp",
  "galarian-rapidash": "Rapidash de Galar",
  slowbro: "Slowbro",
  dodrio: "Dodrio",
  gengar: "Gengar",
  blissey: "Blissey",
  "mr-mime": "Mr. Mime",
  scizor: "Scizor",
  gyarados: "Gyarados",
  "mega-gyarados": "Mega-Gyarados",
  lapras: "Lapras",
  vaporeon: "Vaporeon",
  snorlax: "Snorlax",
  zapdos: "Zapdos",
  moltres: "Moltres",
  dragonite: "Dragonite",
  mewtwox: "Mega-Mewtwo X",
  mewtwoy: "Mega-Mewtwo Y",
  "mega-mewtwo-x": "Mega-Mewtwo X",
  "mega-mewtwo-y": "Mega-Mewtwo Y",
  mew: "Mew",
  azumarill: "Azumarill",
  espeon: "Espeon",
  umbreon: "Umbreon",
  mamoswine: "Mamoswine",
  suicune: "Suicune",
  tyranitar: "Tyranitar",
  "ho-oh": "Ho-Oh",
  blaziken: "Blaziken",
  gardevoir: "Gardevoir",
  sableye: "Sableye",
  absol: "Absol",
  metagross: "Metagross",
  latias: "Latias",
  latios: "Latios",
  empoleon: "Empoleon",
  garchomp: "Garchomp",
  lucario: "Lucario",
  "mega-lucario": "Mega-Lucario",
  leafeon: "Leafeon",
  glaceon: "Glaceon",
  darkrai: "Darkrai",
  crustle: "Crustle",
  zoroark: "Zoroark",
  chandelure: "Chandelure",
  delphox: "Delphox",
  greninja: "Greninja",
  talonflame: "Talonflame",
  aegislash: "Aegislash",
  sylveon: "Sylveon",
  goodra: "Goodra",
  trevenant: "Trevenant",
  hoopa: "Hoopa",
  decidueye: "Decidueye",
  tsareena: "Tsareena",
  comfey: "Comfey",
  mimikyu: "Mimikyu",
  dhelmise: "Dhelmise",
  buzzwole: "Buzzwole",
  zeraora: "Zeraora",
  cinderace: "Cinderace",
  inteleon: "Inteleon",
  greedent: "Greedent",
  eldegoss: "Eldegoss",
  cramorant: "Cramorant",
  sirfetchd: "Sirfetch'd",
  alcremie: "Alcremie",
  falinks: "Falinks",
  duraludon: "Duraludon",
  dragapult: "Dragapult",
  zacian: "Zacian",
  urshifu: "Urshifu",
  meowscarada: "Meowscarada",
  pawmot: "Pawmot",
  armarouge: "Armarouge",
  ceruledge: "Ceruledge",
  tinkaton: "Tinkaton",
  typhlosion: "Typhlosion",
  miraidon: "Miraidon",
  // Maps — names and descriptions
  "map-groudon": "Ruinas Celestiales de Theia",
  "map-groudon.description": "Mapa 5v5 con Groudon.",
  "map-kyogre": "Ruinas Celestiales de Theia",
  "map-kyogre.description": "Mapa 5v5 con Kyogre.",
  "map-rayquaza": "Ruinas Celestiales de Theia",
  "map-rayquaza.description": "Mapa 5v5 con Rayquaza.",
  // Neutrals (wild Pokémon / items)
  accelgor: "Accelgor",
  altaria: "Altaria",
  baltoy: "Baltoy",
  bunnelby: "Bunnelby",
  escavalier: "Escavalier",
  groudon: "Groudon",
  indeedee: "Indeedee",
  kyogre: "Kyogre",
  natu: "Natu",
  rayquaza: "Rayquaza",
  regidrago: "Regidrago",
  regice: "Regice",
  regieleki: "Regieleki",
  regirock: "Regirock",
  registeel: "Registeel",
  salac: "Baya Salac",
  sitrus: "Baya Sitrus",
  xatu: "Xatu",
  // Spawn info (HTML)
  "spawn.info.groudon.boss":
    "<p>Al derrotarlo, todos los compañeros vivos reciben <strong>buff</strong> y <strong>15 puntos aeos</strong>.<br>El buff es <strong>permanente hasta que el portador sea K.O.</strong>. Al ser K.O., el buff <strong>pasa al que lo derrotó</strong>.<br>Da <strong>aumento de velocidad de anotación</strong>, <strong>gran aumento de daño</strong> y <strong>pequeño escudo</strong>.<br>Siempre aparece a las 2:00.</p>",
  "spawn.info.bunnelby.initial":
    "<p><strong>Aparecen al inicio de la partida</strong> y <strong>no reaparecen</strong> al ser derrotados.</p><p>Dan 2 puntos.</p>",
  "spawn.info.bunnelby.lane_940":
    "<p>Empieza a aparecer a las <strong>9:40</strong>.</p><p>Al derrotarlo: <strong>2 puntos</strong>, reaparece tras <strong>60 segundos</strong>.</p><p>Si alguna <strong>primera torre</strong> del carril cae, <strong>desaparece</strong>.</p>",
  "spawn.info.bunnelby.lane_920":
    "<p>Empieza a aparecer a las <strong>9:20</strong>.</p><p>Al derrotarlo: <strong>2 puntos</strong>, reaparece tras <strong>60 segundos</strong>.</p><p>Si alguna <strong>primera torre</strong> del carril cae, <strong>desaparece</strong>.</p>",
  "spawn.info.bunnelby.lane_915":
    "<p>Empieza a aparecer a las <strong>9:15</strong>.</p><p>Al derrotarlo: <strong>2 puntos</strong>, reaparece tras <strong>60 segundos</strong>.</p><p>Si alguna <strong>primera torre</strong> del carril cae, <strong>desaparece</strong>.</p>",
  "spawn.info.accelgor":
    "<p>Empieza a las <strong>9:45</strong>. Derrotado: <strong>4 / 7 puntos</strong> y <strong>buff</strong>. Reaparece en <strong>60 s</strong>. Buff <strong>70 s</strong>: <strong>-10% enfriamiento de movimientos</strong>.</p>",
  "spawn.info.escavalier":
    "<p>Empieza a las <strong>9:45</strong>. Derrotado: <strong>4 / 7 puntos</strong> y <strong>buff</strong>. Reaparece en <strong>60 s</strong>. Buff <strong>70 s</strong>: <strong>daño extra en ataques básicos y ralentiza al rival</strong>.</p>",
  "spawn.info.baltoy.generic":
    "<p>Empieza a las <strong>9:45</strong>. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>.</p>",
  "spawn.info.baltoy.lane_940":
    "<p>Empieza a las <strong>9:40</strong>. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>. <strong>Primera torre</strong> del carril destruida → <strong>desaparece</strong>.</p>",
  "spawn.info.baltoy.lane_920":
    "<p>Empieza a las <strong>9:40</strong>. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>. <strong>Primera torre</strong> del carril destruida → <strong>desaparece</strong>.</p>",
  "spawn.info.baltoy.lane_910":
    "<p>Empieza a las <strong>9:10</strong>. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>. <strong>Primera torre</strong> del carril destruida → <strong>desaparece</strong>.</p>",
  "spawn.info.baltoy.lane_910_only":
    "<p>Empieza a las <strong>9:10</strong>. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>.</p>",
  "spawn.info.baltoy.lane_840":
    "<p>Empieza a las <strong>8:40</strong>. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>.</p>",
  "spawn.info.baltoy.tower":
    "<p>Aparece cuando la <strong>primera torre correspondiente</strong> es destruida. Derrotado: <strong>2 puntos</strong>. Reaparece en <strong>60 s</strong>.</p>",
  "spawn.info.regidrago":
    "<p>Aparece en <strong>el centro del mapa a las 8:00</strong>. Derrotado → <strong>Altaria 1:30 después</strong>.<br>El equipo que lo derrote gana <strong>experiencia para todos</strong>. Golpe final: <strong>buff de anotación</strong> y <strong>20 puntos</strong>.</p>",
  "spawn.info.regieleki":
    "<p>Aparece a las <strong>7:00</strong> en carril superior o inferior. Derrotado → va a la base rival; toca base: <strong>20/16/12/8 puntos</strong>; base viva: <strong>goles instantáneos 20/15/10/5 s</strong>.<br>Golpe final: <strong>20 puntos</strong>. Reaparece <strong>2 min</strong> después.</p>",
  "spawn.info.regi.700":
    "<p>Aparece a las <strong>7:00</strong>.</p>",
  "spawn.info.xatu":
    "<p>Aparece a las <strong>9:59</strong>. Derrotado: <strong>mucha experiencia</strong> y <strong>2 puntos</strong>. <strong>No reaparece</strong>.</p>",
  "spawn.info.natu.900":
    "<p>Aparece a las <strong>9:00</strong>.</p>",
  "spawn.info.natu.920":
    "<p>Aparece a las <strong>9:20</strong>.</p>",
  "spawn.info.indeedee.lane":
    "<p>Empieza a las <strong>9:30</strong> / <strong>9:35</strong>. Derrotado: reaparece en <strong>60 s</strong>, <strong>5 puntos</strong>. <strong>Primera torre</strong> destruida → <strong>desaparece</strong>.</p>",
  "spawn.info.indeedee.tower":
    "<p>Aparece cuando la <strong>primera torre correspondiente</strong> es destruida. Derrotado: reaparece en <strong>60 s</strong>, <strong>5 puntos</strong>.</p>",
  "spawn.info.salac":
    "<p>Al consumir: <strong>bonus de velocidad 3 s</strong>. Aparece a las <strong>8:30</strong>, reaparece <strong>60 s</strong> después de consumir.</p>",
  "spawn.info.salac.short":
    "<p>Bonus de velocidad durante 3 segundos.</p>",
  "spawn.info.altaria.after_regidrago":
    "<p>Aparece <strong>1:30 después de derrotar a Regidrago</strong>.</p>",
  "spawn.info.altaria.rayquaza":
    "<p>Aparece a las <strong>8:00</strong>, reaparece cada <strong>1:30</strong>. Desaparece a las <strong>2:30</strong>.</p>",
  "spawn.info.kyogre.boss":
    "<p>Derrotado: compañeros vivos → <strong>buff</strong>, <strong>15 puntos aeos</strong>, torres rivales aún en pie desactivadas 1:30 (sin escudo/regen).<br>Buff <strong>permanente hasta K.O. del portador</strong>, luego <strong>pasa al que lo derrotó</strong>.<br><strong>Velocidad de anotación</strong>, <strong>regen 5%/s</strong>, <strong>pequeño escudo</strong>. Aparece a las 2:00.</p>",
  "spawn.info.rayquaza.boss":
    "<p>Derrotado: el equipo ganador recibe <strong>15 puntos aeos</strong>, un <strong>escudo</strong> que <strong>acelera el marcador</strong> y <strong>evita que bloqueen goles</strong>. Aparece a las 2:00.</p>",
  "spawn.info.regidrago.kyogre":
    "<p>Aparece en <strong>el centro del mapa a las 8:00</strong>.</p>",
  "spawn.info.xatu.short":
    "<p>Aparece a las <strong>9:59</strong>.</p>",
  "spawn.info.indeedee.tower_break":
    "<p>Aparece al destruir torre.</p>",
  "spawn.info.baltoy.tower_break":
    "<p>Aparece al destruir torre.</p>",
  "spawn.info.bunnelby.lane":
    "<p>Empieza a aparecer a las <strong>9:40</strong>.</p>",
  "spawn.info.bunnelby.lane_920_short":
    "<p>Empieza a aparecer a las <strong>9:20</strong>.</p>",
  "spawn.info.bunnelby.lane_915_short":
    "<p>Empieza a aparecer a las <strong>9:15</strong>.</p>",
  "spawn.info.baltoy.lane_940_short":
    "<p>Empieza a aparecer a las <strong>9:40</strong>.</p>",
  "spawn.info.baltoy.945_short":
    "<p>Empieza a aparecer a las <strong>9:45</strong>.</p>",
  "spawn.info.baltoy.lane_910_short":
    "<p>Empieza a aparecer a las <strong>9:10</strong>.</p>",
  "spawn.info.baltoy.lane_840_short":
    "<p>Empieza a aparecer a las <strong>8:40</strong>.</p>",
  "spawn.info.indeedee.lane_930":
    "<p>Empieza a aparecer a las <strong>9:30</strong>.</p>",
  "spawn.info.indeedee.lane_935":
    "<p>Empieza a aparecer a las <strong>9:35</strong>.</p>",
  "spawn.info.bunnelby.points":
    "<p>Dan 2 puntos.</p>",
  "spawn.info.baltoy.tower_kyogre":
    "<p>Aparece cuando la <strong>primera torre correspondiente</strong> es destruida.</p>",
  "spawn.info.indeedee.tower_short":
    "<p>Aparece cuando la <strong>primera torre correspondiente</strong> es destruida.</p>",
  // @begin move-names-i18n
  "move.acid-spray": "Bomba Ácida",
  "move.acrobatics": "Acróbata",
  "move.aerial-ace": "Golpe Aéreo",
  "move.agility": "Agilidad",
  "move.air-slash": "Tajo Aéreo",
  "move.amnesia": "Amnesia",
  "move.anchor-shot": "Anclaje",
  "move.ancient-power": "Poder Pasado",
  "move.aqua-jet": "Acua Jet",
  "move.aqua-ring": "Acua Aro",
  "move.aqua-tail": "Acua Cola",
  "move.armor-cannon": "Armor Cannon",
  "move.assurance": "Buena Baza",
  "move.astonish": "Impresionar",
  "move.aurora-veil": "Velo Aurora",
  "move.avalanche": "Alud",
  "move.baby-doll-eyes": "Ojitos Tiernos",
  "move.barrier": "Barrera",
  "move.beat-up": "Paliza",
  "move.belch": "Eructo",
  "move.bite": "Mordisco",
  "move.bitter-blade": "Bitter Blade",
  "move.blaze": "Llama",
  "move.blaze-kick": "Patada Ígnea",
  "move.blizzard": "Ventisca",
  "move.block": "Bloqueo",
  "move.bone-rush": "Ataque Óseo",
  "move.bounce": "Bote",
  "move.branch-poke": "Punzada Rama",
  "move.brave-bird": "Pájaro Osado",
  "move.brutal-swing": "Giro Vil",
  "move.bubble": "Burbuja",
  "move.bubble-beam": "Rayo Burbuja",
  "move.bulk-up": "Corpulencia",
  "move.bulldoze": "Terratemblor",
  "move.bullet-punch": "Puño Bala",
  "move.bullet-seed": "Semilladora",
  "move.calm-mind": "Paz Mental",
  "move.charge-beam": "Rayo Carga",
  "move.charm": "Encanto",
  "move.close-combat": "A Bocajarro",
  "move.coaching": "Motivación",
  "move.confuse-ray": "Rayo Confuso",
  "move.confusion": "Confusión",
  "move.cotton-guard": "Rizo Algodón",
  "move.cotton-spore": "Esporagodón",
  "move.covet": "Antojo",
  "move.cross-chop": "Tajo Cruzado",
  "move.curse": "Maldición",
  "move.cut": "Corte",
  "move.dark-pulse": "Pulso Umbrío",
  "move.dark-void": "Brecha Negra",
  "move.dazzling-gleam": "Brillo Mágico",
  "move.decorate": "Decoración",
  "move.defense-curl": "Rizo Defensa",
  "move.detect": "Detección",
  "move.dig": "Excavar",
  "move.disable": "Anulación",
  "move.disarming-voice": "Voz Cautivadora",
  "move.discharge": "Chispazo",
  "move.dive": "Buceo",
  "move.double-hit": "Doble Golpe",
  "move.double-slap": "Doble Bofetón",
  "move.double-team": "Doble Equipo",
  "move.draco-meteor": "Cometa Draco",
  "move.dragon-breath": "Dragoaliento",
  "move.dragon-cheer": "Bramido Dragón",
  "move.dragon-claw": "Garra Dragón",
  "move.dragon-dance": "Danza Dragón",
  "move.dragon-pulse": "Pulso Dragón",
  "move.dragon-rush": "Carga Dragón",
  "move.dragon-tail": "Cola Dragón",
  "move.draining-kiss": "Beso Drenaje",
  "move.dream-eater": "Comesueños",
  "move.drill-peck": "Pico Taladro",
  "move.dual-wingbeat": "Ala Bis",
  "move.dynamic-punch": "Puño Dinámico",
  "move.earthquake": "Terremoto",
  "move.egg-bomb": "Bomba Huevo",
  "move.electro-ball": "Bola Voltio",
  "move.electro-drift": "Electro Drift",
  "move.electroweb": "Electrotela",
  "move.ember": "Ascuas",
  "move.eruption": "Erupción",
  "move.explosive-heat-haze": "Bruma Térmica Explosiva",
  "move.extreme-speed": "Veloc. Extrema",
  "move.fairy-wind": "Viento Feérico",
  "move.fake-out": "Sorpresa",
  "move.fake-tears": "Llanto Falso",
  "move.feather-dance": "Danza Pluma",
  "move.feint": "Amago",
  "move.feint-attack": "Finta",
  "move.fell-stinger": "Aguijón Letal",
  "move.fire-blast": "Llamarada",
  "move.fire-punch": "Puño Fuego",
  "move.fire-spin": "Giro Fuego",
  "move.flail": "Azote",
  "move.flame-burst": "Pirotecnia",
  "move.flame-charge": "Nitrocarga",
  "move.flame-wheel": "Rueda Fuego",
  "move.flamethrower": "Lanzallamas",
  "move.flare-blitz": "Envite Ígneo",
  "move.flash-cannon": "Foco Resplandor",
  "move.flip-turn": "Viraje",
  "move.floral-healing": "Cura Floral",
  "move.flower-trick": "Flower Trick",
  "move.fly": "Vuelo",
  "move.focus-blast": "Onda Certera",
  "move.follow-me": "Señuelo",
  "move.foul-play": "Juego Sucio",
  "move.freeze-dry": "Liofilización",
  "move.fury-cutter": "Corte Furia",
  "move.fury-swipes": "Golpes Furia",
  "move.future-sight": "Premonición",
  "move.giga-drain": "Gigadrenado",
  "move.gigaton-hammer": "Gigaton Hammer",
  "move.grass-knot": "Hierba Lazo",
  "move.grassy-glide": "Fitoimpulso",
  "move.gravity": "Gravedad",
  "move.growl": "Gruñido",
  "move.gyro-ball": "Giro Bola",
  "move.headbutt": "Golpe Cabeza",
  "move.heal-pulse": "Pulso Cura",
  "move.heat-wave": "Onda Ígnea",
  "move.heavy-slam": "Cuerpo Pesado",
  "move.helping-hand": "Refuerzo",
  "move.hex": "Infortunio",
  "move.high-horsepower": "Fuerza Equina",
  "move.hone-claws": "Afilagarras",
  "move.horn-leech": "Asta Drenaje",
  "move.hurricane": "Vendaval",
  "move.hydro-cannon": "Hidrocañón",
  "move.hydro-pump": "Hidrobomba",
  "move.hyper-beam": "Hiperrayo",
  "move.hyper-voice": "Vozarrón",
  "move.hyperspace-hole": "Paso Dimensional",
  "move.hypnosis": "Hipnosis",
  "move.ice-beam": "Rayo Hielo",
  "move.ice-fang": "Colmillo Hielo",
  "move.ice-hammer": "Martillo Hielo",
  "move.ice-shard": "Canto Helado",
  "move.icicle-crash": "Chuzos",
  "move.icicle-spear": "Carámbano",
  "move.icy-wind": "Viento Hielo",
  "move.imprison": "Sellar",
  "move.incinerate": "Calcinación",
  "move.iron-defense": "Defensa Férrea",
  "move.iron-head": "Cabeza de Hierro",
  "move.jump-kick": "Patada Salto",
  "move.karate-chop": "Golpe Kárate",
  "move.knock-off": "Desarme",
  "move.laser-focus": "Aguzar",
  "move.lava-plume": "Humareda",
  "move.leaf-blade": "Hoja Aguda",
  "move.leaf-storm": "Lluevehojas",
  "move.leaf-tornado": "Ciclón de Hojas",
  "move.leafage": "Follaje",
  "move.leech-life": "Chupavidas",
  "move.lick": "Lengüetazo",
  "move.light-screen": "Pantalla de Luz",
  "move.liquidation": "Hidroariete",
  "move.low-sweep": "Puntapié",
  "move.lunge": "Plancha",
  "move.luster-purge": "Resplandor",
  "move.mach-punch": "Ultrapuño",
  "move.magical-leaf": "Hoja Mágica",
  "move.magnet-rise": "Levitón",
  "move.mean-look": "Mal de Ojo",
  "move.mega-punch": "Megapuño",
  "move.megahorn": "Megacuerno",
  "move.metal-claw": "Garra Metal",
  "move.meteor-mash": "Puño Meteoro",
  "move.mist-ball": "Bola Neblina",
  "move.moonblast": "Fuerza Lunar",
  "move.moonlight": "Luz Lunar",
  "move.muddy-water": "Agua Lodosa",
  "move.mystical-fire": "Llama Embrujada",
  "move.nasty-plot": "Maquinación",
  "move.night-shade": "Tinieblas",
  "move.night-slash": "Tajo Umbrío",
  "move.no-retreat": "Bastión Final",
  "move.nuzzle": "Moflete Estático",
  "move.outrage": "Enfado",
  "move.overheat": "Sofoco",
  "move.pain-split": "Divide Dolor",
  "move.parabolic-charge": "Carga Parábola",
  "move.pay-day": "Día de Pago",
  "move.payback": "Vendetta",
  "move.peck": "Picotazo",
  "move.perish-song": "Canto Mortal",
  "move.petal-dance": "Danza Pétalo",
  "move.phantom-force": "Golpe Fantasma",
  "move.play-rough": "Carantoña",
  "move.pollen-puff": "Bola de Polen",
  "move.poltergeist": "Poltergeist",
  "move.pound": "Destructor",
  "move.powder-snow": "Nieve Polvo",
  "move.power-swap": "Cambiafuerza",
  "move.power-up-punch": "Puño Incremento",
  "move.power-whip": "Latigazo",
  "move.psybeam": "Psicorrayo",
  "move.psychic": "Psíquico",
  "move.psycho-cut": "Psicocorte",
  "move.psyshock": "Psicocarga",
  "move.psystrike": "Onda Mental",
  "move.pursuit": "Persecución",
  "move.pyro-ball": "Balón Ígneo",
  "move.quick-attack": "Ataque Rápido",
  "move.rapid-spin": "Giro Rápido",
  "move.razor-leaf": "Hoja Afilada",
  "move.recover": "Recuperación",
  "move.rest": "Descanso",
  "move.rock-polish": "Pulimento",
  "move.rock-slide": "Avalancha",
  "move.rock-smash": "Golpe Roca",
  "move.rock-tomb": "Tumba Rocas",
  "move.rollout": "Rodar",
  "move.sacred-fire": "Fuego Sagrado",
  "move.sacred-sword": "Espada Santa",
  "move.safeguard": "Velo Sagrado",
  "move.sand-attack": "Ataque Arena",
  "move.sand-tomb": "Bucle Arena",
  "move.scald": "Escaldar",
  "move.scratch": "Arañazo",
  "move.seed-bomb": "Bomba Germen",
  "move.shadow-ball": "Bola Sombra",
  "move.shadow-claw": "Garra Umbría",
  "move.shadow-sneak": "Sombra Vil",
  "move.shell-smash": "Rompecoraza",
  "move.sing": "Canto",
  "move.skull-bash": "Cabezazo",
  "move.sky-attack": "Ataque Aéreo",
  "move.slack-off": "Relajo",
  "move.slash": "Cuchillada",
  "move.sludge-bomb": "Bomba Lodo",
  "move.smack-down": "Antiaéreo",
  "move.smart-strike": "Cuerno Certero",
  "move.smokescreen": "Pantalla de Humo",
  "move.snarl": "Alarido",
  "move.snipe-shot": "Disparo Certero",
  "move.soft-boiled": "Amortiguador",
  "move.solar-beam": "Rayo Solar",
  "move.solar-blade": "Cuchilla Solar",
  "move.spark": "Chispa",
  "move.spirit-shackle": "Puntada Sombría",
  "move.splash": "Salpicadura",
  "move.stealth-rock": "Trampa Rocas",
  "move.stomp": "Pisotón",
  "move.stone-edge": "Roca Afilada",
  "move.stored-power": "Poder Reserva",
  "move.stuff-cheeks": "Atiborramiento",
  "move.submission": "Sumisión",
  "move.substitute": "Sustituto",
  "move.sucker-punch": "Golpe Bajo",
  "move.supercell-slam": "Plancha Voltaica",
  "move.superpower": "Fuerza Bruta",
  "move.surf": "Surf",
  "move.surging-strikes": "Azote Torrencial",
  "move.sweet-kiss": "Beso Dulce",
  "move.sweet-scent": "Dulce Aroma",
  "move.swift": "Rapidez",
  "move.swords-dance": "Danza Espada",
  "move.synthesis": "Síntesis",
  "move.tackle": "Placaje",
  "move.tail-whip": "Látigo",
  "move.tailwind": "Viento Afín",
  "move.take-down": "Derribo",
  "move.tearful-look": "Ojos Llorosos",
  "move.telekinesis": "Telequinesis",
  "move.teleport": "Teletransporte",
  "move.thief": "Ladrón",
  "move.throat-chop": "Golpe Mordaza",
  "move.thunder": "Trueno",
  "move.thunder-punch": "Puño Trueno",
  "move.thunder-shock": "Impactrueno",
  "move.thunder-wave": "Onda Trueno",
  "move.thunderbolt": "Rayo",
  "move.trailblaze": "Trailblaze",
  "move.tri-attack": "Triataque",
  "move.trick": "Truco",
  "move.trick-room": "Espacio Raro",
  "move.triple-axel": "Triple Axel",
  "move.trop-kick": "Patada Tropical",
  "move.twister": "Ciclón",
  "move.vine-whip": "Látigo Cepa",
  "move.volt-switch": "Voltiocambio",
  "move.volt-tackle": "Placaje Eléc",
  "move.water-gun": "Pistola Agua",
  "move.water-pulse": "Hidropulso",
  "move.water-shuriken": "Shuriken de Agua",
  "move.water-spout": "Salpicar",
  "move.waterfall": "Cascada",
  "move.whirlpool": "Torbellino",
  "move.wicked-blow": "Golpe Oscuro",
  "move.wide-guard": "Vastaguardia",
  "move.wild-charge": "Voltio Cruel",
  "move.will-o-wisp": "Fuego Fatuo",
  "move.wing-attack": "Ataque Ala",
  "move.wish": "Deseo",
  "move.wood-hammer": "Mazazo",
  "move.x-scissor": "Tijera X",
  "move.yawn": "Bostezo",
  "move.zap-cannon": "Electrocañón",
  "move.zen-headbutt": "Cabezazo Zen",
// @end move-names-i18n
  // Battle Items
  "battle-item.potion": "Poción",
  "battle-item.x-attack": "Ataque X",
  "battle-item.x-speed": "Velocidad X",
  "battle-item.fluffy-tail": "Cola Vaporosa",
  "battle-item.eject-button": "Botón de Expulsión",
  "battle-item.slow-smoke": "Humo Lento",
  "battle-item.full-heal": "Cura Total",
  "battle-item.goal-getter": "Goleador",
  "battle-item.shedinja-doll": "Muñeco Shedinja",
  "battle-item.goal-hacker": "Pirata de Gol",
  // Held Items
  "held-item.leftovers": "Restos",
  "held-item.muscle-band": "Cinta Muscular",
  "held-item.scope-lens": "Lente de Alcance",
  "held-item.wise-glasses": "Gafas Sabias",
  "held-item.shell-bell": "Concha Campanilla",
  "held-item.float-stone": "Piedra Flotante",
  "held-item.focus-band": "Cinta Enfoque",
  "held-item.assault-vest": "Chaleco Asalto",
  "held-item.rocky-helmet": "Casco Férreo",
  "held-item.razor-claw": "Zarpa Afilada",
  "held-item.choice-specs": "Gafas Elegidas",
  "held-item.choice-scarf": "Pañuelo Elegido",
  "held-item.weakness-policy": "Política de Debilidad",
  "held-item.big-root": "Raíz Grande",
  "held-item.amulet-coin": "Monedamuleto",
  "held-item.rusted-sword": "Espada Oxidada",
  "held-item.mewtwonite-x": "Mewdosnita X",
  "held-item.mewtwonite-y": "Mewdosnita Y",
  "held-item.lucarionite": "Lucarionita",
  "held-item.charizardite-x": "Charizardita X",
  "held-item.charizardite-y": "Charizardita Y",
  "held-item.gyaradosite": "Gyaradosita",
};

export default es;
